import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { GroupTypeaheadComponent } from './GroupTypeahead.component';

@NgModule({
    imports: [CommonModule, FormsModule, CoreUiModule],
    declarations: [GroupTypeaheadComponent],
    exports: [GroupTypeaheadComponent],
    providers: []
})
export class GroupTypeaheadModule {}
